import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  actionTo?: string;
  actionLabel?: string;
  icon?: string;
  children?: ReactNode;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  actionTo,
  actionLabel,
  icon,
  children,
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
      <div className="min-w-0">
        {eyebrow && (
          <span className="mb-2 inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-primary-600">
            {icon && <i className={icon} />}
            {eyebrow}
          </span>
        )}
        <h2 className="text-xl font-bold tracking-tight text-foreground-950 md:text-2xl">
          {title}
        </h2>
        {description && (
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
            {description}
          </p>
        )}
      </div>
      {actionTo && actionLabel && (
        <Link
          to={actionTo}
          className="flex shrink-0 items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          {actionLabel}
          <i className="ri-arrow-right-s-line text-lg" />
        </Link>
      )}
      {children}
    </div>
  );
}